import 'intersection-observer'
import 'core-js/es/map'
import 'core-js/es/set'
import 'core-js/es/symbol'
import 'core-js/es/promise'
import 'core-js/es/object'
import 'core-js/es/array'
import 'core-js/es/string'
import 'raf/polyfill'

import './index'
